import { createBeginDrag } from './0cc6f623aba5562dc253f433da5887de17acb0508a0252837731eae2c47a3a4e.cfe-internal.js';
import { createPublishDragSource } from './27cdfee977471da1d956e83a739c42ea927e0dadc677b9ecd335211274964ecc.cfe-internal.js';
import { createHover } from './c143998172d07a9a2410ffcaa6fec5f320f437391f62a69f677cc849dd5c5c0f.cfe-internal.js';
import { createDrop } from './89aeb17344fb06e8cc06635558ac6fadab3a7507c64b21cb852ba14008a9329e.cfe-internal.js';
import { createEndDrag } from './7fba850c887741e15cf48779e259d5312b9f5b13b04240c27fe003f736df1b2b.cfe-internal.js';
export { BEGIN_DRAG, DROP, END_DRAG, HOVER, INIT_COORDS, PUBLISH_DRAG_SOURCE } from './be0378ab1f16348a8496fedc6004874b221f7fe70c6044381814973cb89e98e5.cfe-internal.js';

function createDragDropActions(manager) {
  return {
    beginDrag: createBeginDrag(manager),
    publishDragSource: createPublishDragSource(manager),
    hover: createHover(manager),
    drop: createDrop(manager),
    endDrag: createEndDrag(manager)
  };
}

export { createDragDropActions };
